// Utility to check if error is a chunk loading error (common after deployments)
export const isChunkLoadError = (error) => {
  if (!error) return false;
  const errorMessage = error.message || error.toString();

  // Check for various chunk loading error patterns
  const chunkErrorPatterns = [
    /loading chunk/i,
    /Loading chunk/i,
    /ChunkLoadError/i,
    /failed to fetch dynamically imported module/i,
    /Importing a module script failed/i,
    /Unable to preload CSS/i,
    /Failed to load resource.*\.js/i,
    /Failed to load resource.*\.css/i,
    /Unexpected token '<'/i, // HTML returned instead of JS (old chunk not found)
    /SyntaxError: Unexpected token/i,
  ];

  return chunkErrorPatterns.some(pattern => pattern.test(errorMessage));
};
